import React, { useEffect, useState } from 'react';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { api } from '../lib/api';
import { useLang } from '../context/LangContext';

export const SuccessStories = () => {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);
  const [i, setI] = useState(0);
  useEffect(() => { api.get('/stories').then(({ data }) => setItems(data.stories)).catch(() => {}); }, [lang]);
  useEffect(() => {
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const id = setInterval(() => setI((x) => (x + 1) % items.length), 7000);
    return () => clearInterval(id);
  }, [items]);
  if (!items.length) return null;
  const s = items[i];
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-12" data-testid="success-stories" aria-label={t('Approved after appeal')}>
      <div className="rounded-2xl border-2 border-[#C26227]/30 bg-[#FFF7F0] p-6 md:p-8 relative overflow-hidden">
        <Quote className="w-10 h-10 text-[#C26227]/20 absolute top-4 right-5" aria-hidden />
        <div className="text-xs font-bold uppercase tracking-wider text-[#C26227] mb-3">{t('Approved after appeal')} · {s.program_label}</div>
        <p className="text-lg md:text-xl leading-relaxed max-w-3xl" style={{fontFamily: 'Lexend'}} data-testid="success-story-text" aria-live="polite">“{s.text}”</p>
        <div className="mt-4 flex items-center justify-between gap-3 flex-wrap">
          <div className="text-sm text-muted-foreground">— {t('Anonymous')} · {s.stage}</div>
          {items.length > 1 && (
            <div className="flex items-center gap-2">
              <button onClick={() => setI((i - 1 + items.length) % items.length)} className="w-9 h-9 rounded-full border border-border bg-card flex items-center justify-center hover:border-primary" aria-label={t('Previous story')} data-testid="story-prev"><ChevronLeft className="w-4 h-4" /></button>
              <span className="text-xs text-muted-foreground">{i + 1}/{items.length}</span>
              <button onClick={() => setI((i + 1) % items.length)} className="w-9 h-9 rounded-full border border-border bg-card flex items-center justify-center hover:border-primary" aria-label={t('Next story')} data-testid="story-next"><ChevronRight className="w-4 h-4" /></button>
            </div>
          )}
        </div>
      </div>
      <p className="text-xs text-muted-foreground mt-2">{t('Short anonymous notes from people who kept going. Every story is reviewed before it appears.')}</p>
    </section>
  );
};
